import React from 'react';
import { GWITracker } from 'gwi-tracker';
import PropTypes from 'prop-types';
import logger from '../../../shared/helpers/logger';
import titleCaser from '../../../shared/helpers/title-caser';

class ListCheckbox extends React.Component {

  static propTypes = {
    /*eslint-disable */
    brickData: PropTypes.object.isRequired,
    list: PropTypes.object.isRequired,
    /*eslint-enable */
    checkboxName: PropTypes.string.isRequired,
    listId: PropTypes.number.isRequired,
    updateUserLists: PropTypes.func.isRequired,
  };

  state = {
    value: this.doesListHaveWatchable(),
    listItemId: this.findListItemId(),
  };

  handleChange = () => {
    const brickData = this.props.brickData;
    const currentValue = this.state.value;

    logger.debug('ListCheckbox value:', currentValue);

    if (currentValue === true) {
      if (this.state.listItemId) {
        logger.debug('This list is being removed');

        brickData.api.removeWatchableFromList(
            this.props.list.id,
            this.state.listItemId,
        ).then((response) => {
          logger.debug(response);

          // ***
          GWITracker.trackRemoveFromList(brickData.trackingState);
          // ***

          const lists = brickData.userLists;
          const selectedList = lists.filter(list => list.id === this.props.listId)[0];
          const listItem = selectedList.items.filter(item => item.id === this.state.listItemId)[0];
          const listIndex = selectedList.items.indexOf(listItem);

          if (listIndex > -1) {
            selectedList.items.splice(listIndex, 1);
          }

          this.setState({ value: !this.state.value });
          this.props.updateUserLists(lists);
        }, (xhr, status, err) => {
          logger.error('API call to remove watchable failed.', xhr, status, err);
        });
      }
    } else {
      logger.debug('This list is being added ');
      brickData.api.addWatchableToList(
          this.props.listId,
          brickData.watchableId,
          titleCaser(brickData.watchableType),
      ).then((response) => {
        logger.debug(response);

        // ***
        GWITracker.trackAddToList(brickData.trackingState);
        // ***

        this.setState({ listItemId: response.list_item.id });
        this.setState({ value: !this.state.value });

        const lists = brickData.userLists;
        const selectedList = lists.filter(list => list.id === this.props.listId)[0];

        selectedList.items.push(response.list_item);

        this.props.updateUserLists(lists);
      }, (xhr, status, err) => {
        logger.error('API call to add watchable to list failed.', xhr, status, err);
      });
    }
  };

  doesListHaveWatchable() {
    return this.props.list.items.some(item => item.title === this.props.brickData.title);
  }

  findListItemId() {
    if (this.doesListHaveWatchable()) {
      return this.props.list.items.filter(item => item.title === this.props.brickData.title)[0].id;
    }

    return null;
  }

  render() {
    const boxId = `mybox-${this.props.listId}`;

    return (
      <div className="list-checkbox">
        <input id={boxId} type="checkbox" checked={this.state.value} onChange={this.handleChange} />
        <label className="gwi--checkbox-label" htmlFor={boxId}>
          <span className="gwi--checkbox-span" />
          <p className="gwi--checkbox-name">{ this.props.checkboxName }</p>
          <ins><i>{ this.props.checkboxName }</i></ins>
        </label>
      </div>
    );
  }
}

export default ListCheckbox;



// WEBPACK FOOTER //
// ./src/client/components/list/list-checkbox.jsx